module.exports = __webpack_public_path__ + "img/on_mobile_gift.67832fbb.png";